import React from "react";
import { useComponents } from "~/hooks/useAllComponents";
import { Gallery } from "~/components/Gallery/Gallery";

export const ComponentGallery = ({ limit, shuffle = false, type = "Component" }) => {
  const data = useComponents();
  
  if (!data?.allAirtableComponents?.edges) {
    return null;
  }
  
  let components = data.allAirtableComponents.edges.filter(({ node }) => {
    if (!node?.data?.Type) return false;
    if (type === "Foundation") return node.data.Type === "Foundation";
    if (type === "Token") return node.data.Type === "Token";
    return node.data.Type === "Component" && node.data.Web === "Ready";
  });

  if (shuffle) {
    components = components.sort(() => Math.random() - 0.5);
  } else {
    components = components.sort((a, b) => a.node.data.Name.localeCompare(b.node.data.Name));
  }

  if (limit) {
    components = components.slice(0, limit);
  }

  const items = components.map(({ node }) => {
    const { Name, Slug, Gallery_Image } = node?.data || {};
    const basePath = type === "Foundation" ? "/foundations" : type === "Token" ? "/tokens" : "/components";
    const slug = Slug === "form-input" ? "forms/form-input" : Slug;
    return {
      title: Name || "Untitled",
      link: slug ? `${basePath}/${slug}` : "#",
      image: Gallery_Image?.localFiles?.[0]?.publicURL
    };
  }).filter(item => item.link !== "#");

  return <Gallery items={items} />;
};
